// extracted by mini-css-extract-plugin
export default {"risk-factors__text-box":"style_risk-factors__text-box__bFmSL","risk-factors__container":"style_risk-factors__container__VoFLJ"};